import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  pageTitle: {
    id: 'Pricing.copy.pageTitle',
    defaultMessage: 'SurveyMonkey Plans and Pricing',
    desc: {
      id: 'Pricing.copy.pageTitle',
      message: '[Type: Label][Vis: med] - Page title for Pricing pages',
      project: PROJECT_NAME,
    },
  },
  pageDescription: {
    id: 'Pricing.copy.pageDescription',
    defaultMessage:
      'Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software.',
    desc: {
      id: 'Pricing.copy.pageDescription',
      message: '[Type: Label][Vis: med] - Page meta description for pricing pages',
      project: PROJECT_NAME,
    },
  },
  pageKeywords: {
    id: 'Pricing.copy.pageKeywords',
    defaultMessage:
      'questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys',
    desc: {
      id: 'Pricing.copy.pageKeywords',
      message: '[Type: Label][Vis: med] - Page meta keywords for pricing pages. Includes deliberate misspellings',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
